import { useSelector } from "react-redux";

const Spinner = ({ x, y, type }: { x?: number; y?: number; type?: number }) => {
  const { loaderSpinner } = useSelector((state: any) => state.theme);

  const getUrl = () => {
    if (loaderSpinner) return loaderSpinner;
    return "commons/loader.gif";
  };

  return (
    <img
      className={"spinner"}
      src={`${process.env.PUBLIC_URL}/${getUrl()}`}
      alt={"Loader"}
      style={{ height: y, width: x }}
    />
  );
};

export default Spinner;
